import React from 'react';
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import particlesConfig from '../Shared/pr-s-black';
import '../Assets/Stylesheets/Pages/Tools/DigitaladGenerator.scss';

export default function DigitaladGenerator() {
  const particlesInit = async (engine) => {
    await loadSlim(engine);
  };

  return (
    <div className="digitalad-generator-page">
      <section className="tool-header">
        <div className="particles circle-bg">
          <div className="container">
            <div className="title-box">
              <h1>
                <span className="color-font">DIGITAL AD GENERATOR</span>
              </h1>
            </div>
          </div>
          <Particles id="particles-js" init={particlesInit} options={particlesConfig} />
        </div>
      </section>
      
      <section className="tool-content">
        <div className="container">
          <div className="coming-soon">
            <h2>COMING SOON</h2>
            <p>We're working on bringing you an amazing digital ad generation tool.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
